/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioReferenciasCV from './controladorVista/formularioReferenciasCV';
import TablaReferenciasCV from './controladorVista/tablaReferenciasCV';
import { estadoIncial, reductor } from './reductorReferencias';

const Referencias: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaReferenciasCV />
        <FormularioReferenciasCV />
    </ProveedorEstado>
);

export default Referencias;
